var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "../../../components/templates/flex";
var Image = styled(Flex).attrs({ as: "img" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  object-fit: cover;\n"], ["\n  object-fit: cover;\n"])));
export default Image;
var templateObject_1;
